<script lang="ts">
  import RatingDots from "./RatingDots.svelte"
  import AUBrandText from "./ui/AUBrandText.svelte"

  export let rating: number
  export let ratingText: string
  export let layout: "vertical" | "horizontal"
</script>

<div class="auws-widget-price-rating__wrapper">
  <div
    class="auws-widget-price-rating"
    data-rating={rating}
    data-layout={layout}
  >
    <div class="auws-widget-price-rating__text">
      <AUBrandText>{ratingText}</AUBrandText>
    </div>
    <div class="auws-price-rating-element"><RatingDots {rating} /></div>
  </div>
</div>

<style>
  .auws-widget-price-rating__wrapper {
    width: 100%;
    container: price-rating / inline-size;
  }

  .auws-widget-price-rating {
    width: 100%;
    display: flex;
    gap: 2px;

    flex-direction: column;
    align-items: start;
  }

  .auws-widget-price-rating[data-layout="horizontal"] {
    /* min width is based on font size and length of the text */
    @container price-rating (min-width: 178px) {
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
  }

  .auws-widget-price-rating__text {
    font-size: var(--au-text-body-small-font-size);
    line-height: 1.2;
  }

  .auws-widget-price-rating[data-rating="1"] :global(div:first-child) {
    color: var(--au-rating-1-color);
  }

  .auws-widget-price-rating[data-rating="2"] :global(div:first-child) {
    color: var(--au-rating-2-color);
  }

  .auws-widget-price-rating[data-rating="3"] :global(div:first-child) {
    color: var(--au-rating-3-color);
  }

  .auws-widget-price-rating[data-rating="4"] :global(div:first-child) {
    color: var(--au-rating-4-color);
  }

  .auws-widget-price-rating[data-rating="5"] :global(div:first-child) {
    color: var(--au-rating-5-color);
  }
</style>
